import Vue from 'vue';

const state = {
  mnemonics: {},
  mnemonicIds: [],
};

const getters = {
  mnemonics: state => state.mnemonics,
  mnemonicList: state => state.mnemonicIds.map(id => state.mnemonics[id]),
};

const mutations = {
  setMnemonics: function(state, mnemonics) {
    mnemonics.forEach(card => {
      Vue.set(state.mnemonics, card.id, card);
      if(!state.mnemonicIds.includes(card.id)) {
        state.mnemonicIds.push(card.id);
      }
    });
  },
};

const actions = {
  loadMnemonics({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].get('/mnemonics', { params }).then(response => {
      if (response.data.records) {
        commit('setMnemonics', response.data.records);
        return response.data.records;
      } else {
        commit('setMnemonics', response.data.mnemonics);
        return response.data.mnemonics;
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
